import { render, staticRenderFns } from "./AddToCompare.vue?vue&type=template&id=d5adca6a&"
import script from "./AddToCompare.vue?vue&type=script&lang=js&"
export * from "./AddToCompare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d5adca6a')) {
      api.createRecord('d5adca6a', component.options)
    } else {
      api.reload('d5adca6a', component.options)
    }
    module.hot.accept("./AddToCompare.vue?vue&type=template&id=d5adca6a&", function () {
      api.rerender('d5adca6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/themes/default/components/core/blocks/Compare/AddToCompare.vue"
export default component.exports